<template>   
    <div class="fullwidth">
        <forgot-form/> 
    </div>
</template>

<script> 
import forgotForm from '@/components/forms/auth/forgot';

export default {
    name: 'auth-login',
    components: { 
        forgotForm
    }
}
</script>